import { useTranslation } from 'react-i18next';
import type { CatalogContentBundle } from '@/types/catalog.ts';
import { TextField, BriefingField } from './BaseFields.tsx';

interface SectorFormProps {
  value: CatalogContentBundle;
  onChange: (next: CatalogContentBundle) => void;
  mode: 'create' | 'update';
}

export default function SectorForm({ value, onChange, mode }: SectorFormProps) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <TextField
        label={t('superuser.catalog.form.slug', { defaultValue: 'Slug' })}
        value={value.slug ?? ''}
        onChange={(v) => onChange({ ...value, slug: v })}
        readOnly={mode === 'update'}
        required={mode === 'create'}
        pattern="^[a-z0-9-]+$"
        hint={mode === 'create' ? 'lowercase + guiones' : undefined}
      />
      <TextField
        label={t('superuser.catalog.form.label', { defaultValue: 'Etiqueta' })}
        value={value.label}
        onChange={(v) => onChange({ ...value, label: v })}
        required
      />
      <BriefingField
        value={value.briefing ?? ''}
        onChange={(v) => onChange({ ...value, briefing: v })}
      />
    </div>
  );
}
